<div *ngIf="(inAppLogin | async) && endpoint" style="margin-left: 1em; float: right; ">
    <a class="btn btn-primary" style="border-radius: 0.25rem; color: #fff;" (click)="login();"
        *ngIf="!isAuthenticated() && sameDomain()">
        <!-- TODO: Remove function call from template -->
        {{'COMPOSITIONS.loginToCatalogue' | translateHs }}
    </a>
    <a class="btn btn-primary" style="border-radius: 0.25rem; color: #fff;" (click)="login();"
        *ngIf="!isAuthenticated() && !sameDomain()" [href]="authUrl()" target="_blank">
        <!-- TODO: Remove function call from template -->
        {{'COMPOSITIONS.loginToCatalogue' | translateHs }}
    </a>
    <a class="btn btn-primary text-truncate"
        style="border-radius: 0.25rem; color: #fff; max-width:25ch; white-space:nowrap" (click)="logout()"
        *ngIf="isAuthenticated()">{{'COMMON.Logout' | translateHs }}
        {{endpoint.user}}</a><!-- TODO: Remove function call from template -->
</div>